import {
  THEME_OPTIONS,
  type ThemeValue,
} from '@/layouts/BasicLayout/components/ThemeSelector/constant';
import * as React from 'react';

type ThemeModel = 'dark' | 'light';

type ThemeProviderState = {
  /**
   * default - 默认
   * default-scaled - 紧凑
   */
  theme: ThemeValue;
  /**
   * dark - 暗色模式
   * light - 亮色模式
   */
  themeModel: ThemeModel;
  setThemeModel: (themeModel: ThemeModel) => void;
  setTheme: (theme: ThemeValue) => void;
};

const initialState: ThemeProviderState = {
  theme: THEME_OPTIONS[0]?.value || 'default',
  themeModel: 'light',
  setThemeModel: () => null,
  setTheme: () => null,
};

export const ThemeProviderContext = React.createContext<ThemeProviderState>(initialState);

export const useTheme = () => {
  const context = React.useContext(ThemeProviderContext);

  if (context === undefined) throw new Error('useTheme must be used within a ThemeProvider');

  return context;
};

export type { ThemeModel, ThemeProviderState };
